import { BusinessSettingEnum } from '@core/enums';
import { ConfiguracionGeneral, ConfiguracionCliente, ConfiguracionEmpleado, ConfiguracionSobretiempo, ConfiguracionResponsabilidad, ConfiguracionTienda, ConfiguracionGeneralForm, ConfiguracionClienteForm, ConfiguracionEmpleadoForm, ConfiguracionSobretiempoForm, ConfiguracionResponsabilidadForm, ConfiguracionTiendaForm } from '@models/.';

export function transformBusinessSettingForm(businessSetting:ConfiguracionGeneral): ConfiguracionGeneralForm {
  const {
    configuracionEmpleado: {
      propinas,
      gratificaciones,
      compensacionConductor,
      usarPeriodoPago,
      inicioSemana,
    },
    configuracionSobretiempo: { tipo, horas, tasa },
    configuracionResponsabilidad: {
      responsabilidadVenta,
      responsabilidadPago,
      responsabilidadPropina,
    },
    configuracionTienda: {
      formatoFecha,
      simboloMoneda,
      funcionImprimirPos,
      formatoNombre,
      formatoHora,
      funcionEnviarPos,
      precisionDecimal,
      activarLogs,
      diasBorradoLogInicio,
      diasBorradoLogFin,
      visualizarCuentaCorriente,
    },
    configuracionCliente: { criterioBusqueda },
  } = businessSetting;

  const employeeManagement: ConfiguracionEmpleadoForm = {
    tip: propinas,
    gratuity: gratificaciones,
    driverCompensation: compensacionConductor,
    usePayPeriod: usarPeriodoPago,
    startOfWeek: inicioSemana,
  }

  const overtime: ConfiguracionSobretiempoForm = {
    type: tipo,
    hours: horas,
    rate: tasa,
  }

  const accountability: ConfiguracionResponsabilidadForm = {
    salesAccountability: responsabilidadVenta,
    paymentAccountability: responsabilidadPago,
    tipAccountability: responsabilidadPropina,
  }

  const storeSettings: ConfiguracionTiendaForm = {
    dateFormat: formatoFecha,
    currencySymbol: simboloMoneda,
    printActionInPos: funcionImprimirPos === BusinessSettingEnum.PrintActionOnlyKitchen
      ? BusinessSettingEnum.PrintActionOnlyKitchenLabel
      : BusinessSettingEnum.PrintActionKitchenAndCheckLabel,
    nameFormat: formatoNombre,
    hourFormat: formatoHora,
    sendActionInPos: funcionEnviarPos,
    precision: precisionDecimal.toString(),
    activateLogs: activarLogs,
    daysToDeleteLogsStart: diasBorradoLogInicio,
    daysToDeleteLogsEnd: diasBorradoLogFin,
    viewCurrentAccount: visualizarCuentaCorriente,
  };

  const customerSettings: ConfiguracionClienteForm = {
    defaultSearchCriteria: criterioBusqueda,
  }

  return {
    employeeManagement,
    storeSettings,
    customerSettings,
    overtime,
    accountability
  }
}

export function transformToBusinessSettingUpdate(businessSetting: ConfiguracionGeneralForm): ConfiguracionGeneral {
  const {
    localId,
    employeeManagement: {
      tip,
      gratuity,
      driverCompensation,
      usePayPeriod,
      startOfWeek,
    },
    overtime: { type, hours, rate },
    accountability: {
      salesAccountability,
      paymentAccountability,
      tipAccountability,
    },
    storeSettings: {
      dateFormat,
      currencySymbol,
      printActionInPos,
      nameFormat,
      hourFormat,
      sendActionInPos,
      precision,
      activateLogs,
      daysToDeleteLogsStart,
      daysToDeleteLogsEnd,
      viewCurrentAccount,
    },
    customerSettings: { defaultSearchCriteria },
  } = businessSetting;

  const employeeManagement: ConfiguracionEmpleado = {
    propinas: tip,
    gratificaciones: gratuity,
    compensacionConductor: driverCompensation,
    usarPeriodoPago: usePayPeriod,
    inicioSemana: startOfWeek,
  };

  const overtime: ConfiguracionSobretiempo = {
    tipo: type,
    horas: hours,
    tasa: rate,
  };

  const accountability: ConfiguracionResponsabilidad = {
    responsabilidadVenta: salesAccountability,
    responsabilidadPago: paymentAccountability,
    responsabilidadPropina: tipAccountability,
  };

  const storeSettings: ConfiguracionTienda = {
    formatoFecha: dateFormat,
    simboloMoneda: currencySymbol,
    funcionImprimirPos: printActionInPos === BusinessSettingEnum.PrintActionOnlyKitchenLabel
      ? BusinessSettingEnum.PrintActionOnlyKitchen
      : BusinessSettingEnum.PrintActionKitchenAndCheck,
    formatoNombre: nameFormat,
    formatoHora: hourFormat,
    funcionEnviarPos: sendActionInPos,
    precisionDecimal: parseInt(precision,10),
    activarLogs: activateLogs,
    diasBorradoLogInicio: daysToDeleteLogsStart,
    diasBorradoLogFin: daysToDeleteLogsEnd,
    visualizarCuentaCorriente: viewCurrentAccount
  };

  const customerSettings: ConfiguracionCliente = {
    criterioBusqueda: defaultSearchCriteria,
  };

  return {
    configuracionEmpleado: employeeManagement,
    configuracionSobretiempo: overtime,
    configuracionResponsabilidad: accountability,
    configuracionTienda: storeSettings,
    configuracionCliente: customerSettings,
    localId,
  };
}